export default {
  data() {
    return {
      xDown: null,
      yDown: null,
      gesture: null,
      left: null,
      right: null,
      up: null,
      down: null,
      touchMove: null,
      touchEnd: null,
      isAnimating: false,
    };
  },
  computed: {
    isMobile() {
      return /Mobi/i.test(window.navigator.userAgent);
    }
  },
  methods: {
    viewport() {
      let meta = document.createElement("meta");
      meta.name = "viewport";
      meta.content = "width=device-width,initial-scale=1.0";
      document.head.appendChild(meta);
    },
    handleTouch(e) {
      this.addEvent(e, "touchstart", this.handleTouchStart);
      this.addEvent(e, "mousedown", this.handleTouchStart);
    },
    handleAnimate(e) {
      this.addEvent(e, "transitionstart", () => (this.isAnimating = true));
      this.addEvent(e, "transitionend", () => (this.isAnimating = false));
      this.addEvent(e, "animationstart", () => (this.isAnimating = true));
      this.addEvent(e, "animationend", () => (this.isAnimating = false));
    },
    getTouches(evt) {
      return evt.touches || evt.originalEvent.touches;
    },
    handleTouchStart(evt) {
      if (evt.type == "touchstart") {
        const firstTouch = this.getTouches(evt)[0];
        this.xDown = firstTouch.clientX;
        this.yDown = firstTouch.clientY;
        this.addEvent(window, "touchmove", this.handleTouchMove, {
          passive: false,
        });
        this.addEvent(window, "touchend", this.handleTouchEnd);
      } else {
        this.xDown = evt.clientX;
        this.yDown = evt.clientY;
        this.addEvent(window, "mousemove", this.handleTouchMove, {
          passive: false,
        });
        this.addEvent(window, "mouseup", this.handleTouchEnd);
      }
    },
    handleTouchMove(evt) {
      evt.preventDefault();
      var xUp = evt.type == "touchmove" ? evt.touches[0].clientX : evt.clientX;
      var yUp = evt.type == "touchmove" ? evt.touches[0].clientY : evt.clientY;
      var xDiff = this.xDown - xUp;
      var yDiff = this.yDown - yUp;
      if (Math.abs(xDiff) < Math.abs(yDiff)) {
        this.gesture = yDiff > 0 ? "up" : "down";
      } else {
        this.gesture = xDiff > 0 ? "left" : "right";
      }
      if (this.touchMove) this.touchMove(xUp, yUp);
    },
    handleTouchEnd(evt) {
      if (this.gesture === "left" && this.left) this.left();
      else if (this.gesture === "right" && this.right) this.right();
      else if (this.gesture === "up" && this.up) this.up();
      else if (this.gesture === "down" && this.down) this.down();
      if (this.touchEnd) this.touchEnd();

      this.gesture = null;
      this.xDown = null;
      this.yDown = null;
      if (evt.type == "touchend") {
        this.removeEvent(window, "touchmove", this.handleTouchMove);
        this.removeEvent(window, "touchend", this.handleTouchEnd);
      } else {
        this.removeEvent(window, "mousemove", this.handleTouchMove);
        this.removeEvent(window, "mouseup", this.handleTouchEnd);
      }
    },
  },
};
